













































import {
  defineComponent,
  computed,
  watch,
  getCurrentInstance,
} from '@vue/composition-api';
import { Popup, Button } from '@hb/coffee';
import store from '@/store';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import ProductCommodity from '@/shared/commodity';

export default defineComponent({
  name: 'TempAmountSuccessPopup',
  components: {
    Popup,
    Button,
  },
  setup() {
    // 必须在 setup 同步阶段获取 instance
    const instance = getCurrentInstance();

    /** 弹窗可见性：直接从 applyProduct state 读取 */
    const visible = computed(
      () => store.state.applyProduct.tempAmountEntry?.showSuccessPopup || false,
    );

    /** 自营渠道信息：从 channelList 中获取自营渠道数据（提额只针对自营渠道） */
    const autarkyChannel = computed(() => {
      const channelList = store.state.applyProduct.channelList || [];
      return channelList.find(
        (item) => item.productId === ProductCommodity.AUTARKY_B_COMMODITY,
      );
    });

    /** 可用额度：来自自营渠道的 availableAmount */
    const availableAmount = computed(() => autarkyChannel.value?.availableAmount || '0');

    /** 临时额度：来自自营渠道的 adjustQuota.adjustValue */
    const tempAmount = computed(
      () => autarkyChannel.value?.adjustQuota?.adjustValue?.toString() || '0',
    );

    /** 临额有效期：来自自营渠道的 adjustQuota.tempCreditExpiryTime */
    const tempValidateTime = computed(
      () => autarkyChannel.value?.adjustQuota?.tempCreditExpiryTime || '',
    );

    /** 格式化金额：添加千分位 */
    const formatAmount = (amount: string) => {
      const num = Number(amount);
      if (Number.isNaN(num)) return '0';
      return num.toLocaleString();
    };

    /** 曝光埋点 */
    watch(visible, (newVal) => {
      if (newVal) {
        ubtSetupModuleExpose('finance_loan_apply_tempAmountEntry_success_popup');
      }
    }, { immediate: true });

    /** 关闭弹窗（组件内部实现） */
    const closePopup = () => {
      const { tempAmountEntry } = store.state.applyProduct;
      store.dispatch('applyProduct/$updateState', {
        tempAmountEntry: { ...tempAmountEntry, showSuccessPopup: false },
      });
    };

    /** 点击去提现：关闭弹窗 + 切换到自营渠道 */
    const handleGoWithdraw = () => {
      ubtSetupPageButton('finance_loan_apply_tempAmountEntry_success_popup', { content: 'submit' });
      closePopup();

      // 通过事件总线触发切换到自营渠道（复用现有逻辑）
      if (instance?.proxy?.$root) {
        instance.proxy.$root.$emit('switchToSpeedChannel');
      }
    };

    /** 点击关闭 */
    const handleClose = () => {
      ubtSetupPageButton('finance_loan_apply_tempAmountEntry_success_popup', { content: 'close' });
      closePopup();
    };

    return {
      visible,
      availableAmount,
      tempAmount,
      tempValidateTime,
      formatAmount,
      handleGoWithdraw,
      handleClose,
    };
  },
});
